(() => {
  const init = (root) => {
    if (!root || root.dataset.yhReviewsReady === 'true') return;
    root.dataset.yhReviewsReady = 'true';

    const track = root.querySelector('[data-yh-reviews-track]');
    if (!track) return;

    const prev = root.querySelector('[data-yh-reviews-prev]');
    const next = root.querySelector('[data-yh-reviews-next]');
    const cards = Array.from(track.querySelectorAll('.customer-reviews__card'));
    if (!cards.length) return;

    const scrollByCard = (dir) => {
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap || '16') || 16;
      track.scrollBy({ left: dir * (cardWidth + gap), behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  };

  const boot = () => {
    document.querySelectorAll('[data-yh-reviews]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('[data-yh-reviews]') || event.target;
    if (section?.matches?.('[data-yh-reviews]')) init(section);
  });
})();
